/**
 * @GestionalePD User Header UI
 */
import PropTypes from 'prop-types';
import { Box, Stack, IconButton } from '@mui/material';

//-----------------------------------------------------
import { HeaderRoot, HeaderToolbar } from '../dashboardStyles';
import Iconify from '../../../components/iconify';
import ProfileSwitch from './ProfileSwitch';

/**
 * @param {Function} onOpenNav
 * @returns User Header UI
 */
export default function UserHeader({ onOpenNav }) {
  return (
    <HeaderRoot>
      <HeaderToolbar>
        {/* Header hamburger icon */}
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { lg: 'none' },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        <Box sx={{ flexGrow: 1 }} />

        {/* Profile switch drop-down menu */}
        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          <ProfileSwitch />
        </Stack>
      </HeaderToolbar>
    </HeaderRoot>
  );
}

// UserHeader parameter declaration
UserHeader.propTypes = {
  onOpenNav: PropTypes.func,
};
